<template>
  <!-- CARD LIST -->
   <div class="card-list">
      <user-card-item  v-for="card in list" :card="card" :key="card.id"
        :show-del="showDel"
        @card-click="onCardClick(card)" 
        @card-delete="onCardDelete(card)"/>
   </div>
</template>
  
<script>
  import UserCardItem from "@/components/Payments/Common/UserCardItem";

  export default {
    name: "UserCardsList",
    components: {
      UserCardItem
    },
    emits: [
      'cardClick',
      'cardDelete'
    ],
    data:()=>{
      return {}
    },
    props: {
      list: {
        type: Array
      },
      showDel: {
        type: Boolean
      }
    },
    methods: {
      onCardClick(card) {
        this.$emit('cardClick', card)
      },
      onCardDelete(card) {
        this.$emit('cardDelete', card)
      }
    }
  }
</script>
  
<style scoped lang="scss">
  .card-list {
    >div {
      margin-bottom: 0.5rem;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
</style>